import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { v4 as uuidv4 } from 'uuid';
import { Link, TLinkProps } from '@rbx/ui';
import { useSendToAssistant } from '../hooks/useSendToAssistant';
import { assistantPathSuffix, assistantRootPath } from '../constants/assistantNavConstants';

export enum ELinkType {
  Dynamic = 'dynamic',
  NewTab = 'newTab',
}

export const PROMPT_ID_QUERY_PARAM = 'p';

export type LinkToAssistantProps = {
  prompt: string;
  linkType?: ELinkType;
  children: React.ReactNode;
  onActivate?: () => void;
} & TLinkProps;

export const LinkToAssistant = ({
  prompt,
  linkType = ELinkType.NewTab,
  children,
  onActivate,
  ...restProps
}: LinkToAssistantProps) => {
  const router = useRouter();
  const { sendToAssistant } = useSendToAssistant();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const id = useMemo(() => uuidv4().slice(-6), [prompt]);
  const optionalProps = linkType === ELinkType.NewTab ? { target: '_blank' } : {};
  return (
    <Link
      // href is here for ELinkType.NewTab / for screen-readers.
      // For ELinkType.Dynamic we intercept the click and dynamically send to assistant
      href={`${assistantRootPath}?${PROMPT_ID_QUERY_PARAM}=${id}`} // eslint-disable-line react/forbid-component-props
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        onActivate?.();
        sendToAssistant(id, prompt);
        if (linkType === ELinkType.Dynamic) {
          e.preventDefault();
          e.stopPropagation();
          router.push(`${assistantPathSuffix}?${PROMPT_ID_QUERY_PARAM}=${id}`);
        }
      }}
      {...optionalProps}
      {...restProps}>
      {children}
    </Link>
  );
};
